import { API, BASE } from "./api";

export const APP = { name: "TOTO", tagline: "Every card matters." };

export const imageUri = (rel, token) => (rel ? `${BASE}${rel}${token ? `?token=${encodeURIComponent(token)}` : ""}` : null);
export const promoUri = (p) => (!p ? null : /^https?:\/\//i.test(p) ? p : `${API}/promos/media/${p}`);

export function fmtDate(d) {
  if (!d) return "";
  const dt = new Date(d.length <= 10 ? `${d}T00:00:00` : d);
  if (isNaN(dt.getTime())) return d;
  return dt.toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
}
export function fmtDateTime(d) {
  if (!d) return "—";
  const dt = new Date(d.includes("T") && !/[Zz]|[+-]\d{2}:\d{2}$/.test(d) ? `${d}Z` : d);
  return isNaN(dt.getTime()) ? "—" : dt.toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" });
}
export function timeAgo(iso) {
  if (!iso) return "";
  const m = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return "Just now";
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 7) return `${d}d ago`;
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}
export const rupees = (paise) => `₹${(paise / 100).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
export function periodLabel(days) {
  if (days === 365 || days === 366) return "year";
  if (days === 30 || days === 31) return "month";
  if (days === 7) return "week";
  return `${days} days`;
}
export function greeting() {
  const h = new Date().getHours();
  return h < 12 ? "Good Morning" : h < 17 ? "Good Afternoon" : "Good Evening";
}
export function initials(name = "") {
  const p = name.trim().split(/\s+/).filter(Boolean);
  return ((p[0]?.[0] || "") + (p[1]?.[0] || "")).toUpperCase() || "?";
}
const TONES = [
  ["#FFF7ED", "#EA580C"], ["#ECFDF5", "#059669"], ["#F5F3FF", "#7C3AED"],
  ["#EFF6FF", "#2563EB"], ["#E5E5FD", "#0000EC"], ["#FDF2F8", "#DB2777"],
];
export function tone(seed = "") {
  let h = 0;
  for (const ch of seed) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return TONES[h % TONES.length];
}

export const joinAddress = (c) => (c.area && c.address?.toLowerCase().includes(c.area.toLowerCase()) ? c.address : [c.address, c.area].filter(Boolean).join(", "));
const esc = (v) => String(v ?? "").replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/([,;])/g, "\\$1");
export function buildVcf(c, categoryName) {
  const parts = (c.name || "").trim().split(/\s+/);
  const prefix = /^(dr|mr|mrs|ms|prof)\.?$/i.test(parts[0] || "") && parts.length > 1 ? parts.shift() : "";
  const first = parts.shift() || "";
  const lines = ["BEGIN:VCARD", "VERSION:3.0", `N:${esc(parts.join(" "))};${esc(first)};;${esc(prefix)};`, `FN:${esc(c.name || c.companyName || "Contact")}`];
  if (c.companyName) lines.push(`ORG:${esc(c.companyName)}`);
  if (c.designation) lines.push(`TITLE:${esc(c.designation)}`);
  if (c.phone) lines.push(`TEL;TYPE=CELL:${c.phone}`);
  if (c.alternatePhone) lines.push(`TEL;TYPE=WORK:${c.alternatePhone}`);
  if (c.whatsapp && c.whatsapp !== c.phone) lines.push(`TEL;TYPE=OTHER:${c.whatsapp}`);
  (c.email || "").split(/[,;\s]+/).filter(Boolean).forEach((e) => lines.push(`EMAIL;TYPE=WORK:${e}`));
  if (c.website) lines.push(`URL:${c.website}`);
  if (c.address || c.city) lines.push(`ADR;TYPE=WORK:;;${esc(joinAddress(c))};${esc(c.city)};${esc(c.state)};${esc(c.postalCode)};${esc(c.country)}`);
  if (categoryName) lines.push(`CATEGORIES:${esc(categoryName)}`);
  if (c.notes) lines.push(`NOTE:${esc(c.notes)}`);
  lines.push("END:VCARD");
  return lines.join("\r\n");
}
export function download(content, filename, type) {
  const url = URL.createObjectURL(new Blob([content], { type }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export const vcfName = (c) => `${(c.name || c.companyName || "contact").replace(/[^\w\- ]+/g, "").trim() || "contact"}.vcf`;

const COLS = [
  ["name", "Name"], ["designation", "Designation"], ["companyName", "Company"], ["phone", "Phone"],
  ["alternatePhone", "Alternate Phone"], ["whatsapp", "WhatsApp"], ["email", "Email"], ["website", "Website"],
  ["categoryName", "Category"], ["address", "Address"], ["area", "Area"], ["city", "City"], ["state", "State"],
  ["country", "Country"], ["postalCode", "Postal Code"], ["notes", "Notes"],
];
const cell = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};
export function exportCsv(contacts, catMap) {
  const rows = contacts.map((c) => COLS.map(([k]) => cell(k === "categoryName" ? catMap[c.categoryId] || "" : c[k])).join(","));
  const csv = "\uFEFF" + [COLS.map((c) => c[1]).join(","), ...rows].join("\r\n");
  download(csv, `TOTO-contacts-${new Date().toISOString().slice(0, 10)}.csv`, "text/csv;charset=utf-8;");
}

export async function toJpeg(file, max = 1600, quality = 0.85) {
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((res, rej) => {
      const i = new Image();
      i.onload = () => res(i);
      i.onerror = rej;
      i.src = url;
    });
    const scale = Math.min(1, max / Math.max(img.width, img.height));
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);
    canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
    return await new Promise((res) => canvas.toBlob((b) => res(b || file), "image/jpeg", quality));
  } catch {
    return file;
  } finally {
    URL.revokeObjectURL(url);
  }
}

const IMG_EXT = /\.(jpe?g|png|webp|gif|bmp|heic|heif|avif)$/i;
export const isImageFile = (f) => !!f && ((f.type || "").startsWith("image/") || IMG_EXT.test(f.name || ""));

export async function prepareImage(f) {
  let src = f;
  if (/hei[cf]/i.test(f.type || "") || /\.hei[cf]$/i.test(f.name || "")) {
    const { default: heic2any } = await import("heic2any");
    const out = await heic2any({ blob: f, toType: "image/jpeg", quality: 0.9 });
    src = new File([Array.isArray(out) ? out[0] : out], `${(f.name || "card").replace(/\.\w+$/, "")}.jpg`, { type: "image/jpeg" });
  }
  const j = await toJpeg(src, 2000, 0.9);
  return j === src ? src : new File([j], `${(f.name || "card").replace(/\.\w+$/, "")}.jpg`, { type: "image/jpeg" });
}

export function googleContactsUrl(c) {
  const parts = (c.name && c.name !== c.companyName ? c.name : "").trim().split(/\s+/).filter(Boolean);
  const p = new URLSearchParams();
  if (parts.length) p.set("givenname", parts.length > 1 ? parts.slice(0, -1).join(" ") : parts[0]);
  if (parts.length > 1) p.set("familyname", parts[parts.length - 1]);
  if (!parts.length && c.companyName) p.set("givenname", c.companyName);
  const email = (c.email || "").split(/[,;\s]+/).find(Boolean);
  if (email) p.set("email", email);
  const phone = (c.phone || c.alternatePhone || "").replace(/[^\d+]/g, "");
  if (phone) p.set("phone", phone);
  return `https://contacts.google.com/new?${p.toString()}`;
}
